import { ComuniTopic } from '../constants';
import { SYSTEM_MODELS, type ComuniChannel } from './catalog';
import { topicOfTemplateName } from './topicPrefix';

export type WorkspaceTemplateRow = {
  id: string;
  channel: ComuniChannel;
  name: string;
  detail: string;
  formData: Record<string, unknown>;
};

export type PartitionedWorkspaceTemplates = {
  /** Prefixed customs attached to each known topic (catalog exact names excluded). */
  customsByTopic: Map<ComuniTopic, WorkspaceTemplateRow[]>;
  /** Unprefixed / unknown-prefix templates for My templates. */
  myTemplates: WorkspaceTemplateRow[];
};

/** Exact `template_name` values shipped in the system catalog. */
export const catalogTemplateNames = (models = SYSTEM_MODELS): Set<string> =>
  new Set(models.map((model) => model.formData.template_name));

/**
 * Split workspace templates for the Modelli list:
 * - known `<topic>__…` → topic group (unless name equals a catalog template_name)
 * - no known prefix → My templates
 */
export const partitionWorkspaceTemplates = (
  rows: WorkspaceTemplateRow[],
  catalogNames: Set<string> = catalogTemplateNames()
): PartitionedWorkspaceTemplates => {
  const customsByTopic = new Map<ComuniTopic, WorkspaceTemplateRow[]>();
  const myTemplates: WorkspaceTemplateRow[] = [];

  for (const row of rows) {
    const topic = topicOfTemplateName(row.name);
    if (!topic) {
      myTemplates.push(row);
      continue;
    }
    if (catalogNames.has(row.name)) {
      // Represented by the system row + WA status; do not list again as a custom.
      continue;
    }
    const list = customsByTopic.get(topic);
    if (list) list.push(row);
    else customsByTopic.set(topic, [row]);
  }

  return { customsByTopic, myTemplates };
};
